import React from "react";
import { Route, Routes, useSearchParams } from "react-router-dom";
import { FlightDroneProvider } from "./provider/flight-drone-provider";
import { DronesPage } from "./pages/drones-page";
import { DroneProvider } from "@src/core/features";
import { DRONES_PAGE_VISIBLE_STATUSES } from "@src/features/drone/utils/operational-drones";

const DroneFeature: React.FC = () => {
  const [searchParams] = useSearchParams();
  const hasDroneSerial = Boolean(searchParams.get('droneSerial'));
  const statuses = hasDroneSerial ? undefined : [...DRONES_PAGE_VISIBLE_STATUSES];

  return (
    <DroneProvider statuses={statuses}>
      <FlightDroneProvider>
        <Routes>
          <Route index element={<DronesPage />}/>
        </Routes>
      </FlightDroneProvider>
    </DroneProvider>
  );
};

export default DroneFeature;
